import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.998",
  height: "16",
  "data-name": "Oko EYE hiden"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626997",
      d: "M13.123 13.093a9.2 9.2 0 0 1-4.125.98A10.08 10.08 0 0 1 .146 8.26L0 7.98l.146-.276a11.2 11.2 0 0 1 3.744-4.24L1.396.87l.955-.869 14.547 15.127-.975.873ZM1.273 7.98a8.9 8.9 0 0 0 7.725 4.9 8.1 8.1 0 0 0 3.281-.7l-.9-.93a3.72 3.72 0 0 1-4.924-.434 4.1 4.1 0 0 1-.418-5.123L4.699 4.311A9.9 9.9 0 0 0 1.273 7.98m5.176 0a2.9 2.9 0 0 0 .787 2.013 2.7 2.7 0 0 0 1.936.834 2.6 2.6 0 0 0 1.4-.416L6.847 6.539a2.9 2.9 0 0 0-.398 1.441m7.887 2.73a10 10 0 0 0 2.393-2.912A8.7 8.7 0 0 0 9.167 2.99a7.8 7.8 0 0 0-1.986.271l-.885-.924a9 9 0 0 1 2.871-.486 9.88 9.88 0 0 1 8.672 5.7l.16.27-.145.271a11.3 11.3 0 0 1-2.74 3.425ZM11.82 8.36a2.5 2.5 0 0 0 .033-.421 2.727 2.727 0 0 0-2.674-2.757 3 3 0 0 0-.4.034l-.881-.944a3.5 3.5 0 0 1 1.3-.247 3.837 3.837 0 0 1 3.758 3.914 4 4 0 0 1-.236 1.368Z",
      "data-name": "Union 315"
    }, null, -1)
  ]))]))
}
export default { render: render }